<template>
  <div class="d-flex justify-content-center">
    <div class="overflow-auto" >
      <div class="container-fluid w-100 p-0">
        <div
          class="p-2 text-center"
          style="background-color: #623a29; width: 100%"
        >
          <marquee
            scrolldelay="85"
            onmouseover="this.stop();"
            onmouseout="this.start();"
          >
            <a
              href="https://bloomprenatalyoga.in/webinar/"
              class="text-white text-decoration-none"
            >
              <i class="fas fa-circle fs-6"></i> WEBINAR ON NUTRITION DURING
              PREGNANCY
            </a>
          </marquee>
        </div>
      </div>
      <div class="container-fluid w-100">
        <div
          class="row text-start p-2"
          style="background-color: #ff7435; font-size: 15px"
        >
          <!-- Mobile & Email (Side by Side) -->
          <div class="col-1">

          </div>
          <div class="col-6  mb-2">
            <a
              href="tel:+919845269938"
              class="text-white text-decoration-none me-3"
            >
              <i class="fas fa-mobile-alt"></i> +91 9845269938
            </a>
            <a
              href="mailto:vaishganu96@gmail.com"
              class="text-white text-decoration-none"
            >
              <i class="far fa-envelope"></i> vaishganu96@gmail.com
            </a>
             <a
              href="https://goo.gl/maps/udiRpj6Pxkai9E4v5"
              class="text-white text-decoration-none"
            >
              <i class="fas fa-star"></i> Google Reviews
            </a>
          </div>
          <div class="col-5 menu text-end">
            <a href="https://www.facebook.com/Bloom-Pre-Natal-and-Therapy-Yoga-106629080744456/" target="_blank">
              <i class="fab fa-facebook"></i>
            </a>
<a href="https://www.instagram.com/bloom.prenatal.yoga/" target="_blank">
              <i class="fab fa-instagram"></i>
            </a>
            <a href="https://www.youtube.com/channel/UCpv1CZNmFsbOV2klFg8Ceiw" target="_blank">
              <i class="fab fa-youtube"></i>
            </a>
             <a href="https://bloomprenatalyoga.in/app/#/login">
              <i class="fas fa-sign-in-alt"></i>
            </a>
          </div>
          <!-- Google Reviews (Centered Below) -->
          
        </div>
      </div>
      <div class="container d-flex justify-content-center">
        <div
          class="position-relative text-center text-white d-flex flex-column align-items-center"
          style="max-width: 100vw"
        >
        <div>
          <a href="https://bloomprenatalyoga.in/">
              <img
                src="https://bloomprenatalyoga.in/wp-content/uploads/2021/08/Logo-c.png"
                
                width="20%"
                alt="Bloom Prenatal Yoga Logo"
              />
            </a>
        </div>
          <!-- Content Section -->
         <!--  <div class="p-3 mt-1">
            <div class="px-3 py-1 rounded" style="background-color: #ff7345">
              <h2 class="h6 fw-bold text-white mt-2">14 DAY ONLINE</h2>
            </div>
            <div class="mt-2">
              <h2 class="text-dark fw-bold">FREE YOGA</h2>
              <hr class="w-50 mx-auto border-dark" />
              <div class="d-flex justify-content-center gap-2 text-dark">
                <i class="fas fa-calendar-alt fa-lg"></i>
                <h3 class="fw-bold fs-5">
                  <span class="fs-6">Starts</span> Monday, 3<sup>rd</sup> FEB
                </h3>
              </div>
            </div>
          </div> -->

          <!-- Background Image Section -->
          <div
            class="w-100"
            style="
              background: url('/app/images/lotus-index.jpg') no-repeat center/cover;
              height: 300px;
            "
          ></div>
          <div class="px-4 bg-white w-100 text-dark p-4" id="login">
            <!--  <form action="#" method="POST"> -->
          

            <div class="mb-3 d-flex align-items-center gap-2">
              <!-- Country Code -->
              <div
                class="d-flex align-items-center border border-secondary py-2 px-3 rounded"
              >
                <img src="https://flagcdn.com/in.svg" alt="India flag" width="24" />
                <span class="ms-2 text-secondary">+91</span>
              </div>
              <!-- Phone Input -->
              <input
                type="text"
                placeholder="WhatsApp Number"
                required
                v-model="login.mobile"
                class="form-control border-secondary text-dark"
              />
            </div>
  <div class="mb-3">
              <input
                type="password"
                id="password"
                name="password"
                v-model="login.password"
                placeholder="Enter Password"
                maxlength="100"
                class="form-control border-secondary text-dark"
                required
              />
            </div>
            <button
              type="submit"
              class="btn btn-primary w-100 rounded text-white fw-semibold py-2"
              style="
                background: linear-gradient(to right, #ff7345, #d06c4b);
                border: none;
              "
              @click="loginFn()"
            >
              Login In <i class="fas fa-arrow-right"></i>
            </button>
            <!--   </form> -->

          <!--   <p class="text-primary text-center mt-3 fw-bold">
              <span class="fw-bold">4,108+ </span>already attended
            </p> -->
          </div>
        </div>
        
      </div>
       <footer class="text-white py-3" style="background-color: #62392b">
        <div class="container text-center text-md-start">
          <div class="row align-items-center">
            <div class="row">
              <div class="col-md-3 text-white mt-5">
                <!-- Logo Section -->
                <div class="col-md-4 text-center text-md-start mb-3">
                  <img
                    src="https://bloomprenatalyoga.in/wp-content/uploads/2021/08/logo-1.png"
                    alt="Bloom Logo"
                    style="max-width: 215px"
                  />
                </div>

                <!-- Description Section -->
                <div class="col-md-12 text-center">
                  <p class="mb-3">
                    Founded in Bengaluru, we believe in nurturing a healthy bond
                    between mothers and babies for a joyful 10-month journey.
                  </p>
                </div>

                <!-- Social Icons -->
                <div class="col-md-12 text-center">
                  <a
                    href="https://www.facebook.com/Bloom-Pre-Natal-and-Therapy-Yoga-106629080744456/"
                    target="_blank"
                    class="btn btn-light rounded-circle"
                  >
                    <i class="fab fa-facebook"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/bloom.prenatal.yoga/"
                    target="_blank"
                    class="btn btn-light rounded-circle"
                  >
                    <i class="fab fa-instagram"></i>
                  </a>
                  <a
                    href="https://www.youtube.com/channel/UCpv1CZNmFsbOV2klFg8Ceiw"
                    target="_blank"
                    class="btn btn-light rounded-circle"
                  >
                    <i class="fab fa-youtube"></i>
                  </a>
                </div>
              </div>

              <div class="col-md-3 text-white mt-5 ">
                <h2 class="mb-3">Contact Info</h2>

                <!-- Phone Number -->
                <p>
                  <a
                    href="tel:+919845269938"
                    class="text-white text-decoration-none w-100"
                  >
                    T: +91 98452 69938
                  </a>
                </p>

                <!-- Address -->
                <p>
                  <a
                    href="javascript:void(0)"
                    class="text-white text-decoration-none w-100"
                  >
                    A: D-5 Greenview Apartments
                  </a>
                </p>
                <p>
                  <a
                    href="javascript:void(0)"
                    class="text-white text-decoration-none w-100"
                  >
                    #82, 30th Cross Rd, 4th T Block
                  </a>
                </p>
                <p>
                  <a
                    href="javascript:void(0)"
                    class="text-white text-decoration-none w-100"
                  >
                    East, KV Layout, Jayanagar
                  </a>
                </p>
                <p>
                  <a
                    href="javascript:void(0)"
                    class="text-white text-decoration-none w-100"
                  >
                    Bengaluru, Karnataka 560041
                  </a>
                </p>

                <!-- Email -->
                <p>
                  <a
                    href="mailto:vaishganu96@gmail.com"
                    class="text-white text-decoration-none w-100"
                  >
                    E: vaishganu96@gmail.com
                  </a>
                </p>
              </div>
              <div class="col-md-3  mt-5">
                <h2 class="mb-3">Quick Links</h2>

                <!-- Quick Links Navigation -->

                <p>
                  <a
                    href="https://bloomprenatalyoga.in/about-prenatal-yoga/"
                    class="text-decoration-none text-white"
                    >ABOUT PRENATAL YOGA</a
                  >
                </p>
                <p>
                  <a
                    href="https://bloomprenatalyoga.in/classes/"
                    class="text-decoration-none text-white"
                    >CLASSES</a
                  >
                </p>
                <p>
                  <a
                    href="https://bloomprenatalyoga.in/meet-the-therapist/"
                    class="text-decoration-none text-white"
                    >MEET THE THERAPIST</a
                  >
                </p>
                <p>
                  <a
                    href="https://bloomprenatalyoga.in/blog/"
                    class="text-decoration-none text-white"
                    >BLOG</a
                  >
                </p>
                <p>
                  <a
                    href="https://www.google.com/maps/place/Bloom+Prenatal+and+Therapy+Yoga/@12.9292587,77.5876775,15z/data=!4m5!3m4!1s0x0:0x25861bb09f56c46a!8m2!3d12.9292553!4d77.5876764"
                    class="text-decoration-none text-white"
                    >GOOGLE REVIEWS</a
                  >
                </p>
              </div>
              <div class="col-md-3 text-center  mt-5 mb-3">
                <h2 class="mb-3">Google Maps</h2>
                <div class="ratio ratio-16x9">
                  <iframe
                    loading="lazy"
                    src="https://maps.google.com/maps?q=Bloom%20Prenatal%20and%20Therapy%20Yoga&amp;t=m&amp;z=16&amp;output=embed&amp;iwloc=near"
                    title="Bloom Prenatal and Therapy Yoga"
                    aria-label="Bloom Prenatal and Therapy Yoga"
                  >
                  </iframe>
                </div>
              </div>
            </div>

            <hr />
            <div class="container text-center">
              <span
                >Copyright © 2022
                <strong>Bloom Prenatal and Therapy Yoga</strong> | Designed by
                <a href="#" class="text-white"><strong>FMIM</strong></a>
              </span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  setup() {
    const router = useRouter();
    const store = useStore();
    const login = ref({
      password: "",
      mobile: "",
    });
    const loginFn = async () => {
      try {
        const response = await fetch(`${process.env.VUE_APP_API_URL}user/register`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(login.value),
        });
        if(!response.ok){
          alert('Please contact to 9845269938')
        }
        const data = await response.json();
        if (data.token) {
          store.commit("setUser", { token: data.token, id: data.id });

          fetch(`${process.env.VUE_APP_API_URL}package/${data.id}`).then(
        async (res) => {
          let details = await res.json();
          const validateTo = new Date(details[0].validateTo);
const today = new Date();
const diffTime = validateTo - today;
const days = diffTime > 0 ? Math.floor(diffTime / (1000 * 60 * 60 * 24)) : 0;
store.commit("setExpiredIn", days)
          if(new Date(details[0].validateTo) > new Date()){
            store.commit("setUserValidity", true);
          } else {
            store.commit("setUserValidity", false);

          }
          
        }
      );

          router.push("/dashboard");
        }
      } catch (error) {
        console.log(error);
      }
    };
    return {
      login,
      loginFn,
    };
  },
};
</script>

<style>
.position-relative {
  position: relative;
}
.overlay-text {
  position: absolute;
  bottom: -17px; /* or top: 10px; for top position */
  left: 10px;
  color: white;
  font-weight: bold;
  background: rgba(0, 0, 0, 0.5); /* optional: for better contrast */
  padding: 5px 10px;
  border-radius: 5px;
  width: 95%;
}
.menu a {
      margin-right: 5px;
      background: black;
    border: 1px solid black;
    border-radius: 50%;
    padding: 5px;
}
.menu a i {
  color: white;
}
footer {
  width: 100vw;
}
.imgTitle {
  position: relative;
    bottom: 80px;
    left: 20px;

}
</style>
